import type { AxiosResponse } from 'axios';

const data = async <T>(promise: Promise<AxiosResponse<T>>) =>
  (await promise).data;

export { data };
